module.exports = __webpack_public_path__ + "img/hr-V-R-6-unload-connect.60972593.png";